(function () {
    'use strict';

    angular.module('sempraWebapp').factory('periodicSummaryActions', periodicSummaryActionsFactory);

    /** @ngInject */
    function periodicSummaryActionsFactory(api, $q) {
        return {
            getPeriodicSummary: getPeriodicSummary,
            getInvoices : getInvoices,
            updateInvoice : updateInvoice,
            downloadB2bSpec: downloadB2bSpec,
            downloadB2cSpec: downloadB2cSpec,
            downloadInvoice: downloadInvoice,
            getBusinessTransactions: getBusinessTransactions,
            downloadBusinessInvoice: downloadBusinessInvoice
        };

        function getPeriodicSummary() {
            var deferred = $q.defer();
            api.getPeriodicSummary().then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getInvoices(selectedYear, selectedType, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getInvoices(selectedYear, selectedType, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getBusinessTransactions(fromMonth, toMonth, year, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getBusinessTransactions(fromMonth, toMonth, year, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function updateInvoice(id, number, status) {
            var deferred = $q.defer();
            api.updateInvoice(id, number, status).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);

            });
            return deferred.promise;
        }

        function downloadInvoice(transactionId){
            var deferred = $q.defer();
            api.downloadInvoice(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function downloadBusinessInvoice(userId, month, year){
            var deferred = $q.defer();
            api.downloadBusinessInvoice(userId, month, year).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function downloadB2bSpec(transactionId){
            var deferred = $q.defer();
            api.downloadB2bSpec(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });
      
            return deferred.promise;
          }
      
          function downloadB2cSpec(transactionId){
            var deferred = $q.defer();
            api.downloadB2cSpec(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });
      
            return deferred.promise;
          }

    }
})();
